import httpRequest from '../request/indexBase'

const perModuleType = '1'

// 查询文件夹最近使用列表-前10
export function getRecentlyUsedFolderList(params) {
  return httpRequest.get({
    url: `/user/recently-used-folder/getRecentlyUsedFolderList`,
    params
  })
}

// 查询文件夹协作者
export function queryFolderCollaborators(params, perFolderId = '') {
  return httpRequest.get({
    url: `/permission/team-data-permission/getDataPermissionList`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}

// 云空间查询
export function queryCloudSpace(params) {
  return httpRequest.get({
    url: `/repository/data-cloud-space/getCloudSpace`,
    params
  })
}

// 查询模块权限列表
export function queryModulePermissions(params) {
  return httpRequest.get({
    url: `/permission/data-permission/getSystemDataPermissionList`,
    params
  })
}

// 查询解析状态
export function getAnalyzeStatus(params, perFolderId = '') {
  return httpRequest.get({
    url: `/file/getSpellAnalysisStatus`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}

//提示词解析
export function analyzePrompt(data, perFolderId = '') {
  return httpRequest.post({
    url: '/file/spellAnalysisPicture',
    data: data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

// 知识库查询解析状态
export function databaseGetAnalyzeStatus(params, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/data-library-detail/getSpellAnalysisBaseStatus`,
    params: {
      ...params,
      perFolderId,
      perModuleType: '0'
    }
  })
}

// 知识库提示词解析
export function databaseAnalyzePrompt(data, perFolderId = '') {
  return httpRequest.post({
    url: '/weaviate/data-library-detail/spellAnalysisBasePicture',
    data: data,
    params: {
      perFolderId,
      perModuleType: '0'
    }
  })
}
